import EventEmitter2 from './esm/eventemitter2.js'

EventEmitter2.EventEmitter = EventEmitter2
export const EventEmitter = EventEmitter2
export default EventEmitter
